import { Component, type ErrorInfo, type ReactNode } from 'react';
import { TriangleAlert } from 'lucide-react';

import { AppRoutes } from './routes';
import { Button } from './components/Button';

/**
 * Последний рубеж: непойманная ошибка рендера не должна оставлять диспетчера
 * перед белым экраном — показываем сообщение и даём перезагрузить кабинет.
 */
class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Ошибка интерфейса Теплотранзит', error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) {
      return this.props.children;
    }
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 px-6 text-center">
        <TriangleAlert className="h-12 w-12 text-blocked" aria-hidden />
        <h1 className="text-xl font-semibold text-slate-900">Интерфейс не смог отобразить раздел</h1>
        <p className="max-w-lg text-sm text-slate-600">{error.message}</p>
        <Button variant="secondary" onClick={() => window.location.reload()}>
          Перезагрузить
        </Button>
      </div>
    );
  }
}

export function App() {
  return (
    <ErrorBoundary>
      <AppRoutes />
    </ErrorBoundary>
  );
}

export default App;
